var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CRS',{staticClass:"svg-icon",attrs:{"fill":"white","height":_vm.height,"width":_vm.width}})}
var staticRenderFns = []

export { render, staticRenderFns }